import { render } from "./P049.vue?vue&type=template&id=2df7b524&scoped=true"
import script from "./P049.vue?vue&type=script&lang=js"
export * from "./P049.vue?vue&type=script&lang=js"

import "./P049.vue?vue&type=style&index=0&id=2df7b524&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2df7b524"]])

export default __exports__